<template>
  <div class="baseSet" v-auth="`Content.QuestiongroupSeting.Save`">
    <a-form-model
      layout="inline"
      :model="form"
      :rules="modleRules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="right"
      ref="addForm"
      class="baseForm"
    >
      <a-row class="form-row">
        <a-col :span="16">
          <a-col :span="12">
            <a-form-model-item label="题目壳名称" ref="name" prop="name">
              <a-input v-model="form.name" :maxLength="30"
                       @change="e => form.name = e.target.value.replace(/\s*/g, '')" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="版本名称">
              <a-input v-model="form.versionName" :maxLength="30" placeholder="请输入版本名称" />
            </a-form-model-item>
          </a-col>
          <a-col :span="16">
            <a-form-model-item label="适用年龄段" ref="minAge" prop="minAge" :label-col="{span: 6}">
              <a-input-number v-model="form.minAge" type="number" :precision="0" :min="1" :max="150"
                              style="width:48%;" />
              -
              <a-input-number v-model="form.maxAge" type="number" :precision="0" :min="form.minAge" :max="150"
                              style="width:48%;" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="取题数量" class="qNum" ref="pushQuestionNum" prop="pushQuestionNum">
              <a-select v-model="form.pushQuestionType" placeholder="请选择" style="width:48%;" @change="changeNum">
                <a-select-option :value="0">全部取题</a-select-option>
                <a-select-option :value="1">手动取题</a-select-option>
              </a-select>
              <a-input-number v-model="form.pushQuestionNum" :disabled="numDisabled" :precision="0" :min="0" :max="99"
                              style="width:48%;" @blur="() => {$refs.pushQuestionNum.onFieldBlur()}" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="选择模板" ref="grouptemplateId" prop="grouptemplateId">
              <a-select allowClear v-model="form.grouptemplateId" placeholder="请选择">
                <a-select-option :value="item.id" v-for="item in template" :key="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="完成方式" ref="finishType" prop="finishType">
              <a-select allowClear v-model="form.finishType" @change="dataEndTime = undefined" placeholder="请选择">
                <a-select-option :value="1">不限时</a-select-option>
                <a-select-option :value="2">限时</a-select-option>
                <a-select-option :value="3">定时</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="结束时长" :prop="form.finishType === 1 ? undefined : 'endTime'">
              <a-time-picker style="width:100%;" @change="changeTime" :disabled="![2, 3].includes(form.finishType)" v-model="dataEndTime">
                <div slot="addon" style="display: flex;">
                  <span style="width:33%;text-align:center;">时</span>
                  <span style="width:33%;text-align:center;">分</span>
                  <span style="width:33%;text-align:center;">秒</span>
                </div>
              </a-time-picker>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="$route.query.contentType != 5">
            <a-form-model-item>
              <span class="ant-form-item-required" slot="label">排序</span>
              <a-radio-group v-model="form.orderType">
                <a-radio :value="1">随机</a-radio>
                <a-radio :value="2">手动</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item>
              <span class="ant-form-item-required" slot="label">题目壳模式</span>
              <a-radio-group v-model="form.groupModel">
                <a-radio :value="1">测评</a-radio>
                <a-radio :value="2">训练</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item>
              <span class="ant-form-item-required" slot="label">答题顺序</span>
              <a-radio-group v-model="form.isAnswerInOrder">
                <a-radio :value="1">顺序答题</a-radio>
                <a-radio :value="0">间隔答题</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item>
              <span class="ant-form-item-required" slot="label">每题分页</span>
              <a-switch default-checked v-model="form.isPerPage" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item>
              <span class="ant-form-item-required" slot="label">得分显示</span>
              <a-switch default-checked v-model="form.isShowScore" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item>
              <span class="ant-form-item-required" slot="label">状态</span>
              <a-switch
                :checked="form.enabled"
                @change="StatusChange"
                :disabled="pagetype === 'add'" />
            </a-form-model-item>
          </a-col>
          <a-form-model-item label="描述" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
            <a-input v-model="form.description" :rows="4" :maxLength="500" type="textarea" />
          </a-form-model-item>
          <a-form-model-item label="备注" :labelCol="{span: 4}" :wrapperCol="{span: 20}">
            <a-input v-model="form.remark" :rows="4" :maxLength="500" type="textarea" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item ref="coverPlanUri" prop="coverPlanUri" label="banner">
            <div class="bannerUpload">
              <a-upload
                name="imgFile"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :headers="headers"
                :action=" baseURL"
                @change="changeBanner"
                :before-upload="beforeBanner"
              >
                <div v-if="form.coverPlanUri">
                  <a-icon
                    v-show="bimgLoading"
                    style="position: absolute; top: 45%; left: 45%"
                    type="loading"
                  />
                  <img style="width: 150px;height: 45px;object-fit: contain" :src="form.coverPlanUri | filterUrl"
                       alt="avatar">
                </div>
                <div v-else>
                  <a-icon :type="bannerloading ? 'loading' : 'plus'" />
                </div>
              </a-upload>
            </div>
          </a-form-model-item>
          <a-form-model-item style="margin: 60px 0 0;" ref="icon" prop="icon" label="icon">
            <div class="iconUpload">
              <a-upload
                name="imgFile"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :headers="headers"
                :action=" baseURL"
                @change="changeIcon"
                :before-upload="beforeIcon"
              >
                <div v-if="form.icon">
                  <a-icon
                    v-show="imgLoading"
                    style="position: absolute; top: 45%; left: 45%"
                    type="loading"
                  />
                  <img style="width: 150px;height: 150px;" :src="form.icon | filterUrl" alt="avatar">
                </div>
                <div v-else>
                  <a-icon :type="iconloading ? 'loading' : 'plus'" />
                </div>
              </a-upload>
            </div>
          </a-form-model-item>

        </a-col>
        <a-col :span="24" style="display: flex;justify-content: center;"
               v-permission="`Content.QuestiongroupSeting.Save`">
          <a-button type="primary" @click="onSubmit">保存信息</a-button>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import Apis from "@/requests/apis";
import moment from "moment";
import { FormatDate } from "@/pages/projectImpl/js/utils";

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

export default {
  name: "baseSet",
  data() {
    return {
      moment,
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      form: {
        name: "",
        versionName: undefined,
        minAge: undefined,
        maxAge: "",
        description: "",
        remark: "",
        icon: "",
        coverPlanUri: "",
        enabled: false,
        contentType: +this.$route.query.contentType || 3,
        pushQuestionType: 0,
        pushQuestionNum: 0,
        endTime: "",
        orderType: +this.$route.query.contentType == 5 ? 2 : 1,
        groupModel: 1,
        isAnswerInOrder: 1,
        isPerPage: false,
        isShowScore: false,
        grouptemplateId: undefined,
        finishType: 2,
        Num: undefined,
      },
      modleRules: {
        endTime: [{ required: true, message: "请选择结束时间", trigger: "blur" }],
        name: [{ required: true, message: "请填写题目壳名称", trigger: "blur" }],
        minAge: [{ required: true, message: "请填写适用年龄段", trigger: "blur" }],

        icon: [{ required: true, message: "请选择Icon", trigger: "change" }],
        coverPlanUri: [{ required: true, message: "请选择Banner", trigger: "change" }],
        finishType: [{ required: true, message: "请选择完成方式", trigger: "change" }],
        grouptemplateId: [{ required: true, message: "请选择模板", trigger: "change" }],
        pushQuestionNum: [
          { required: true, message: "请填写取题数量", trigger: "blur" },
        ],
      },
      dataEndTime: undefined,
      numDisabled: true,
      // icon
      iconloading: false,
      imgLoading: false,
      // banner
      bannerloading: false,
      bimgLoading: false,
      baseURL: process.env.VUE_APP_API_BASE_URL + Apis.File.upload + "?filePath=content/game/questiongroup",
      headers: {
        Authorization: "",
      },
      template: [],
      currentId: this.$store.getters["content/getQuestionGroupInfo"]().id,
      pagetype: this.$store.getters["content/getQuestionGroupInfo"]() ? "edit" : "add",
      contentDetail: {}, //内容详情
      contentVersionId: "",
    };
  },
  created() {
    let token = localStorage.getItem("token");
    this.headers.Authorization = "Bearer " + token;
    this.getTemplate();
    // 编辑数据的回显
    if (this.currentId && this.pagetype == "edit") {
      this.getDetailByid();
    }
  },
  watch: {
    "form.finishType"() {
      if (this.form.finishType == 1) {
        this.$refs.addForm.clearValidate("endTime");
      }
    },
  },
  methods: {
    changeIcon(info) {
      if (info.fileList[0].response) {
        this.form.icon = info.fileList[0].response.data;
      }
      if (info.file.status === "uploading") {
        this.iconloading = true;
        this.imgLoading = true;
        return;
      }
      if (info.file.status === "done") {
        this.form.icon = info.file.response.data;
        this.iconloading = false;
        this.imgLoading = false;
        this.$refs.addForm.validateField("icon");
      }
    },
    beforeIcon(file) {
      const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("请上传jpg或者png图片!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片大小不能超过2M!");
      }
      return isJpgOrPng && isLt2M;
    },
    changeBanner(info) {
      if (info.fileList[0].response) {
        this.form.coverPlanUri = info.fileList[0].response.data;
      }
      if (info.file.status === "uploading") {
        this.bannerloading = true;
        this.bimgLoading = true;
        return;
      }
      if (info.file.status === "done") {
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.form.coverPlanUri = info.file.response.data;
          this.bannerloading = false;
          this.bimgLoading = false;
          this.$refs.addForm.validateField("coverPlanUri");
        });
      }
    },
    beforeBanner(file) {
      const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("请上传jpg或者png图片!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片大小不能超过2M!");
      }
      return isJpgOrPng && isLt2M;
    },
    // 保存按钮
    onSubmit() {
      if (this.form.finishType === 1) {
        this.form.endTime = "";
      }
      if (this.form.pushQuestionType == 1 && this.form.pushQuestionNum == 0) {
        this.$message.destroy();
        this.$message.warning("取题数量为1-99");
        this.form.pushQuestionNum = 1;
        return;
      }
      // this.form.pushQuestionNum = this.form.pushQuestionNum == null ? 0 : this.form.pushQuestionNum
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (this.form.minAge > this.form.maxAge) {
            this.$message.destroy();
            this.$message.error("最大年龄应大于等于最小年龄");
            return;
          }
          if (this.form.endTime.indexOf("中国标准时间") > 0) {
            this.form.endTime = FormatDate(this.form.endTime, "hh:mm:ss");
          }
          if (this.pagetype == "add") {
            this.addEGamege();
          } else {
            this.editEGamege();
          }
        }
      });
    },
    addEGamege() {
      let params = {
        content: this.form,
        contentVersionId: 0,
      };
      this.$http.AddTrainingGame(params)
        .then(res => {
            this.$message.success("添加成功");
            sessionStorage.setItem("currentName", this.form.name);
            sessionStorage.setItem("currentId", res.data.data.contentId);
            this.form.id = res.data.data.contentId;
            this.contentVersionId = res.data.data.contentVersionId;
            this.currentId = res.data.data.contentId;
            this.pagetype = "edit";
            this.getDetailByid();
            this.$store.commit("content/setQuestionGroupInfo", {
              id: this.form.id,
              contentName: this.form.name,
              versionName: this.form.versionName,
            });
            // 向父组件传参 修改add为edit
            this.$emit("changeType", "edit");

        });
    },
    editEGamege() {
      let params = {
        content: this.form,
        contentVersionId: this.contentVersionId,
        uri: "",
      };
      this.form.id = this.currentId;
      this.$http.EditTrainingGame(params)
        .then(res => {
            this.$message.destroy();
            // sessionStorage保存修改后数据的name
            sessionStorage.setItem("currentName", this.form.name);
            this.$emit("changeType", "edit");
            this.$message.success("修改成功");
            this.getDetailByid();

        });
    },
    getDetailByid() {
      let params = {
        id: this.currentId,
      };
      this.$http.GetTrainingContentDetail(params)
        .then(res => {
            this.contentVersionId = res.data.contentVersionId;

            this.form.id = res.data.id;
            this.contentDetail = res.data;
            this.form = res.data;
            this.form.grouptemplateId = res.data.grouptemplateId || undefined;
            this.form.enabled = res.data.enabled;
            this.form.suitableCourses = res.data.suitableCourses ? res.data.suitableCourses : [];
            this.form.isPerPage = res.data.isPerPage == 1 ? true : false;
            this.form.isShowScore = res.data.isShowScore == 1 ? true : false;
            console.log(this.form.suitableCourses);
            // 取题数量是否大于0
            if (res.data.pushQuestionNum > 0) {
              this.form.pushQuestionNum = res.data.pushQuestionNum;
              this.form.pushQuestionType = 1;
              this.numDisabled = false;
            } else {
              this.form.pushQuestionType = 0;
              this.numDisabled = true;
            }
            if (this.form.endTime) {
              this.dataEndTime = moment(this.form.endTime, "HH:mm:ss");
            }

        });
    },
    // 判断是否能够修改状态
    StatusChange() {
      if (this.pagetype == "edit") {
        const fn = () => {
          let formData = new FormData();
          formData.append("id", this.currentId);
          formData.append("enabled", this.form.enabled);
          this.$http.contentCheckStatus(formData).then(res => {
              this.form.enabled = !this.form.enabled;

          });
        };
        if (this.form.enabled) {
          this.form.enabled = true;
          this.$confirm({
            title: `确认禁用【${this.form.name}】`,
            content: "题目壳禁用后，已配置的课程将移除该题目壳且不可恢复，请谨慎操作",
            centered: true,
            onOk: fn,
          });
          return;
        }
        fn();
      }

    },
    getTemplate() {
      this.$http.questiongrouptemplate()
        .then(res => {
            this.template = res.data.data;

        });
    },
    changeNum(value) {
      if (value == 0) {
        this.numDisabled = true;
        this.form.pushQuestionNum = 0;
        // this.modleRules.pushQuestionNum[0].required = false
      } else {
        this.numDisabled = false;
        this.modleRules.pushQuestionNum[0].required = true;
        this.form.pushQuestionNum = 1;
      }
    },
    changeTime(value) {
      let time = value._d;
      this.form.endTime = time + "";
      this.$refs.addForm.validateField("endTime");
    },
  },
};
</script>

<style scoped lang="less">
.baseSet {
  width: 100%;

  h1 {
    font-size: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
  }

  .ant-form-item {
    width: 100%;
    margin-bottom: 20px;
  }

  .baseForm {
    position: relative;
    // width: 50%;
    margin: 0 auto;

    label {
      font-size: 16px;
      display: inline-block;
    }
  }

  .iconUpload /deep/ .ant-upload.ant-upload-select-picture-card {
    width: 150px;
    height: 150px;
  }

  .bannerUpload /deep/ .ant-upload.ant-upload-select-picture-card {
    width: 150px;
    height: 50px;
  }

  .qNum {
    /deep/ .ant-form-item-children {
      display: flex;
      justify-content: space-between;
    }
  }

  /deep/ .ant-input-number-disabled .ant-input-number-input {
    display: none;
  }
}
</style>
